import { useFormik } from "formik";
import React, { useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

import NibbleInput from "../../../components/Fields/NibbleInput";
import { postUserSendPin } from "../../../helpers/backend_helper";

const ValidatePhone = ({ userValidation }) => {
  console.log({ userValidation });
  const [pinSent, setPinSent] = useState("");
  const [modal, setModal] = useState({
    show: false,
  });
  const [isSendingPing, setIsSendingPin] = useState(false);

  const user = userValidation.values;
  const isValidNumber = user.cellphone && !userValidation.errors.cellphone;

  const onSubmit = (formValues) => {
    if (pinSent != formValues.pin) {
      validation.setFieldError("pin", "El PIN ingresado es incorrecto");
      return;
    }

    userValidation.setFieldValue("phone_validated", 1);

    modalToggle();
  };

  const validation = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: Yup.object({
      pin: Yup.string().required().label("PIN"),
    }),
    onSubmit,
  });

  const modalToggle = () => {
    setModal({ show: !modal.show });
  };

  const sendPin = () => {
    setIsSendingPin(true);

    postUserSendPin({ phone: user.cellphone })
      .then((resp) => {
        setPinSent(resp.pin);
      })
      .finally(() => {
        setIsSendingPin(false);
      });
  };

  return (
    <>
      {user.phone_validated ? (
        <div className="input-group-text bg-white">
          <i
            title="Teléfono validado"
            className="fas fa-check-circle text-success"
          ></i>
        </div>
      ) : (
        <div
          className="input-group-text bg-white"
          style={{ cursor: isValidNumber ? "pointer" : "not-allowed" }}
          role="button"
          onClick={() => {
            if (!isValidNumber) return;

            validation.resetForm();
            modalToggle();
            sendPin();
          }}
          title="Validar por Whats App"
        >
          <i
            title="Validar teléfono"
            className={`fab fa-whatsapp ${isValidNumber && "text-success"}`}
          ></i>
        </div>
      )}
      {modal.show && (
        <Modal isOpen={modal.show}>
          <ModalHeader className="bg-primary">
            Ingresa el PIN enviado por Whats App
          </ModalHeader>
          <ModalBody>
            {isSendingPing ? (
              <div className="text-center">
                <Spinner size="sm" />
                <p>Enviando PIN</p>
              </div>
            ) : (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
                id="validate-phone-form"
              >
                <Row className="justify-content-center align-content-center">
                  <NibbleInput
                    md={6}
                    label="PIN:"
                    fieldName="pin"
                    fieldType="text"
                    validation={validation}
                  />
                </Row>
              </Form>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              form="validate-phone-form"
              color="primary"
              type="button"
              disabled={isSendingPing}
              onClick={() => {
                validation.handleSubmit();
              }}
            >
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button
              color="secondary"
              onClick={modalToggle}
              disabled={isSendingPing}
            >
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default ValidatePhone;
